define('__original__/MainLayout',['require','marionette','lib/theme/ThemeSettings'],function (require) {
	
	var Marionette = require('marionette');
    
    var ThemeSettings = require('lib/theme/ThemeSettings');
	
	return Marionette.LayoutView.extend({

	    template: '#main_layout',

	    regions: {
	    	menu: '#sb_menu',
	        content: '#sb_content',
			footerMenu: {
				'selector': '#sb_footer_menu',
				'allowMissingEl': true
			},
			pushNotifications: '#sb_push_notifications'
	    },
	    ui: {
	    	closeWidgetButton: '#sb_close_widget_button'
		},
	    events: {
	    	'click @ui.closeWidgetButton': 'closeWidget'
		},

		initialize: function () {
            Marionette.LayoutView.prototype.initialize.apply(this);

            this.cid = 'MainLayout';
		},

	    getContentRegion: function () {
	    	return this.content;
	    },

	    getMenuRegion: function () {
	    	return this.menu;
	    },

		getFooterMenuRegion: function() {
	    	return this.footerMenu;
		},

		getPushNotificationsRegion: function() {
	    	return this.pushNotifications;
		},

        closeWidget: function () {
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                    'event': 'closeWidget'
                }, '*');
            }
        },

        serializeData: function () {
	    	var config = Config.getInstance();
            
            var contentGridSettings = ThemeSettings.getInstance().getOption('index_page_content_grid');
            var contentGrid = contentGridSettings ? JSON.parse(contentGridSettings) : null;
            var visibleBlocks = contentGrid ? _.flatten(_.map(contentGrid, function (row) {return row.items || []; })) : [];
            
            return _.extend(Marionette.LayoutView.prototype.serializeData.apply(this), config.getOption('company_data'), {
                current_url: location.href,
                map_key: config.getOption('map_api_key'),
                visible_blocks: visibleBlocks
                // is_map_visible: isMapVisible
			});
        }

	});

});
